'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('store/product/detail'));
    // removed for GALSUP-182
    // processInclude(require('core/product/wishlist'));
    let features = JSON.parse(document.querySelector('body').dataset.features);
    if (features && features.enableOverrideBuyNowURL && features.enableOverrideBuyNowURL) {
        processInclude(require('store/pdpBuyNow'));
    }
    if (features && features.enableChannelSite && features.enablePdpBuyNow) {
        processInclude(require('channelsight/csPdp'));
    }
    if (features && features.overridePdpCsModalWithExternalUrl) {
        processInclude(require('channelsight/csPdpExternalUrls'));
    }
});
